<template lang="html">

  <section class="politica-de-privacidad">
    <div class="legal" v-html="texto"></div>
  </section>

</template>

<script lang="js">

  import axios from 'axios';

  export default {
    name: 'politica-de-privacidad',
    props: [],
    mounted() {
      this.setData();
    },
    data() {
      return {
        texto : ''
      }
    },
    methods: {
      setData() {
        const apiURL = "https://apin-datahub-prod-001.azure-api.net/api";
        const clave = "PP - CALIDAD PASCUAL SUSCRIPCION WEB NEWSLETTER DOUBLEDOT";

        axios.get(`${apiURL}/texto-legal-extendido/${clave}?area_mkt_desc=Pascual Corporativo`).then(result => {
          this.texto = result.data.Texto;
        });
      }
    },
    computed: {}
  }
</script>

<style scoped lang="scss">
  .politica-de-privacidad {}
</style>


// WEBPACK FOOTER //
// src/components/views/politica-de-privacidad.vue